import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const DeviceWin = styled.div`
  background: ${props => props.theme.bg};
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  overflow: hidden;
`;

const Flexer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  justify-content: ${props => (props.centered ? 'center' : 'flex-start')};
  align-items: ${props => (props.centered ? 'center' : 'flex-start')};
  z-index: 1;
`;

const Screen = ({ children, theme, centered }) => (
  <ThemeProvider theme={theme}>
    <DeviceWin>
      <Flexer centered={centered}>{children}</Flexer>
    </DeviceWin>
  </ThemeProvider>
);

export default withTheme(Screen);



// WEBPACK FOOTER //
// ./src/components/Screen.js